import { create } from "zustand";
// using alternate approach right now not using this
const useTimerStore = create((set) => ({
  selectedProject: "",
  setSelectedProject: (project) => set(() => ({ selectedProject: project })),
  isStarted: false,
  setIsStarted: (isStarted) => set(() => ({ isStarted: isStarted })),
  timerDescription: "",
  setTimerDescription: (description) =>
    set(() => ({ timerDescription: description })),
  //   time: 0,
  //   setTime: (time) => {
  //     set({ time: time });
  //     console.log("time2222", time);
  //   },
}));

export default useTimerStore;
